import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function HotRecommend() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="热门推荐" data-product-shop="">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-500">大家都在看的精彩内容</p>
          </div>
          <Link
            to="/category/movie?sort=hot"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {hotMovies.map((movie, idx) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  loading={idx < 10 ? undefined : 'lazy'}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-xs font-semibold bg-accent-500 text-white rounded-md">
                    {movie.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <div className="flex items-center justify-center">
                    <span className="px-4 py-1.5 text-xs bg-primary-500 text-white rounded-full font-medium whitespace-nowrap">
                      <i className="ri-play-fill mr-1"></i>立即观看
                    </span>
                  </div>
                </div>
                {movie.isNew && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 text-[10px] font-semibold bg-primary-500 text-white rounded-md">
                      NEW
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{movie.updateInfo}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}